import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';

const CustomEdit = memo(({ link }) => {
    return (
        
                <NavLink className="d-flex align-items-center" to={link}>
                    <i className="bx bx-edit-alt" /> {/* Change icon class if you're using FontAwesome */}
                </NavLink>
           
    )
})

export default CustomEdit